import React from "react";
import { Menu } from "@mantine/core";
import Typography from "@mui/material/Typography";
import { colors, sizes } from "../../configs";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import OutputIcon from "@mui/icons-material/Output";
import BeenhereOutlinedIcon from "@mui/icons-material/BeenhereOutlined";

const links = [
  {
    title: "My Profile",
    url: "/profile",
    icon: (
      <AccountCircleOutlinedIcon
        sx={{
          color: colors.main,
        }}
      />
    ),
  },
  {
    title: "Manage Account",
    url: "/account",
    icon: (
      <PersonOutlineOutlinedIcon
        sx={{
          color: colors.main,
        }}
      />
    ),
  },
  {
    title: "Bookings",
    url: "/mybookings",
    icon: (
      <WorkOutlineIcon
        sx={{
          color: colors.main,
        }}
      />
    ),
  },
  {
    title: "My Wallet",
    url: "/wallet",
    icon: (
      <AccountBalanceWalletOutlinedIcon
        sx={{
          color: colors.main,
        }}
      />
    ),
  },
  {
    title: "My Rewards",
    url: "/rewards",
    icon: (
      <BeenhereOutlinedIcon
        sx={{
          color: colors.main,
        }}
      />
    ),
  },
  {
    title: "Sign Out",
    url: "/logout",
    icon: (
      <OutputIcon
        sx={{
          color: colors.main,
        }}
      />
    ),
  },
];

const ProfileMenu = () => {
  return (
    <div>
      <Menu.Dropdown
        id="profileDrop"
        sx={{
          padding: "15px 15px",
          borderRadius: sizes.radius,
          border: "1px solid blue",
        }}>
        {links.map((lk, idx) => (
          <Menu.Item key={idx} component="a" href={lk.url}>
            <Typography
              variant="body2"
              component="code"
              style={{
                fontWeight: "100",
                fontSize: sizes.dropDownItemSize,
                color: "GrayText",
              }}>
              {lk.icon}
            </Typography>
            <Typography
              variant="body2"
              component="code"
              style={{
                fontWeight: "bolder",
                fontSize: sizes.dropDownItemSize,
                marginLeft: "15px",
              }}>
              {lk.title}
            </Typography>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </div>
  );
};

export default ProfileMenu;
